import React from "react";
import { Trans, useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

export default function SessionExpiryDialog({ open, canExtend, onExtend, onLogout }) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: "0 18px 60px rgba(0,0,0,0.25)",
        },
      }}
      BackdropProps={{
        sx: { backgroundColor: "rgba(0,0,0,0.45)" },
      }}
    >
      <Box
        sx={{
          height: 6,
          background: canExtend
            ? "linear-gradient(90deg, #FFB020, #FF6B00)"
            : "linear-gradient(90deg, #EF5350, #D32F2F)",
        }}
      />

      <DialogTitle sx={{ pt: 2.5, pb: 1.5 }}>
        <Stack direction="row" spacing={1.2} alignItems="center">
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 2,
              display: "grid",
              placeItems: "center",
              backgroundColor: canExtend ? "rgba(255,176,32,0.15)" : "rgba(239,83,80,0.15)",
            }}
          >
            <WarningAmberRoundedIcon color={canExtend ? "warning" : "error"} />
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              {t("auth.session.title")}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t("auth.session.subtitle")}
            </Typography>
          </Box>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 2 }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {t("auth.session.expiring")}
        </Typography>

        {canExtend ? (
          <Typography variant="body2" color="text.secondary">
            <Trans i18nKey="auth.session.canExtend" components={{ b: <b /> }} />
          </Typography>
        ) : (
          <Typography variant="body2" color="error">
            {t("auth.session.noExtend")}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onLogout}
          variant="outlined"
          color="inherit"
          sx={{
            borderRadius: 2,
            px: 2.2,
            textTransform: "none",
          }}
        >
          {t("auth.session.logout")}
        </Button>

        <Button
          onClick={onExtend}
          variant="contained"
          disabled={!canExtend}
          sx={{
            borderRadius: 2,
            px: 2.4,
            textTransform: "none",
            boxShadow: "0 10px 24px rgba(0,0,0,0.18)",
          }}
        >
          {t("auth.session.extend")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
